import { Command } from 'commander';
import { spaceListCommand } from './list.js';
import { spaceCreateCommand } from './create.js';
import { spaceShowCommand } from './show.js';
import { spaceMembersCommand } from './members.js';
import { spaceInviteCommand } from './invite.js';
import { spaceRemoveCommand } from './remove.js';
import { spaceArchiveCommand } from './archive.js';

export const spaceCommand = new Command('space')
  .description('Manage spaces')
  .addCommand(spaceListCommand)
  .addCommand(spaceCreateCommand)
  .addCommand(spaceShowCommand)
  .addCommand(spaceMembersCommand)
  .addCommand(spaceInviteCommand)
  .addCommand(spaceRemoveCommand)
  .addCommand(spaceArchiveCommand);
